import UnpublishedIcon from "@mui/icons-material/Unpublished";
import React from "react";
import { ListStateIcon } from "../ListStateIcon/ListStateIcon";

interface ListStateIconUnpublishedProps {
    color?: string;
    noMargin?: boolean;
    tooltip?: string;
  }
  
export const ListStateIconUnpublished = ({
    noMargin,
    tooltip,
    color,
}: ListStateIconUnpublishedProps) => (
    <ListStateIcon
        color={color}
        noMargin={noMargin}
        tooltip={tooltip}
        icon={UnpublishedIcon}
    />
);
